import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import React from 'react';

interface ConfirmButtonProps {
  className?: string;
  label?: string;
  onClick: () => void;
}

function ConfirmButton({ className, label, onClick }: ConfirmButtonProps): JSX.Element {
  const [openDialog, setOpenDialog] = React.useState(false);

  const handleClick = () => {
    setOpenDialog(true);
  };

  const handleDialogAccept = () => {
    onClick();
  };

  const handleDialogCancel = () => {
    setOpenDialog(false);
  };

  return (
    <>
      <Button variant='contained' color='secondary' onClick={handleClick} className={className}>
        {label}
      </Button>
      <Dialog open={openDialog} onClose={handleDialogCancel}>
        <DialogTitle>{label}</DialogTitle>
        <DialogContent>
          <DialogContentText>This action cannot be undone. Do you want to proceed?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogCancel} color='primary'>
            Cancel
          </Button>
          <Button onClick={handleDialogAccept} color='primary' autoFocus>
            Accept
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

ConfirmButton.defaultProps = {
  className: undefined,
  label: 'Confirm Action',
};

export default ConfirmButton;
